"use client";

import React from "react";
import { MessageCircle, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function SicilianPastryEssence() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="lessenza-della-pasticceria-siciliana" className="dark relative flex min-h-screen w-full items-center justify-center overflow-hidden bg-background text-foreground">
      {}
      <img src="https://dolcisaporisciacca.blueowlmedia.it/wp-content/uploads/2026/03/Cannolo-Siciliano-psticceria-artigianale-Sicilia-Dolci-Sapori-Sciacca-1.webp" sizes="100vw" loading="eager" className="absolute inset-0 z-0 h-full w-full object-cover" role="img" aria-label="Cannolo siciliano con zucchero a velo sospeso nell'aria" />

      {}
      <div className="absolute inset-0 z-10 bg-[radial-gradient(circle_at_center,transparent_10%,var(--background)_110%)] opacity-90" />
      <div className="absolute inset-0 z-10 bg-background/20" />

      {}
      <div className="relative z-20 container mx-auto px-4 text-center">
        <div ref={ref} className={`flex flex-col items-center justify-center space-y-10 transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
          {}
          <h1 className="font-serif text-5xl font-bold leading-tight tracking-tight text-foreground shadow-2xl drop-shadow-2xl border-[rgb(246,243,238)] !border-1 !border-none sm:text-6xl md:text-7xl lg:text-8xl">La vera pasticceria siciliana a Sciacca</h1>

          <p className="max-w-2xl font-sans text-lg font-medium text-white drop-shadow-lg md:text-xl lg:text-2xl">
            Dolci artigianali preparati ogni giorno, con ricette della tradizione e ingredienti selezionati.
          </p>

          {}
          <div className="flex flex-col items-center gap-4 sm:flex-row sm:gap-6">
            {}
            <Button asChild variant="secondary" size="lg" className="h-14 rounded-full px-8 text-lg font-medium shadow-lg transition-transform duration-300 hover:scale-105 hover:shadow-xl">
              <Link to="https://wa.me/393402498369" newTab>Ordina su WhatsApp</Link>
            </Button>

            {}
            <Button asChild variant="outline" size="lg" className="h-14 rounded-full border-2 border-primary bg-background/10 text-lg font-medium text-primary shadow-lg backdrop-blur-sm transition-transform duration-300 hover:scale-105 hover:bg-primary hover:text-primary-foreground hover:shadow-xl">
              <Link to="/CatalogPage">
                Scopri i Dolci
                <ArrowRight className="ml-2 size-5" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}